/**
 * Gold newsletter CTA band (converted from the `.section.gold-section` block on
 * products.html / detail_category.html). This is the gold variant of the
 * newsletter — distinct from the black `@/components/sections/newsletter`. The
 * form validates and shows the original success state client-side (no backend,
 * per the conversion scope). Grid ids are kept verbatim from the export.
 */
import type { FC, FormEvent } from 'react'

import { useState } from 'react'

export const GoldCta: FC = () => {
    const [email, setEmail] = useState('')
    const [submitted, setSubmitted] = useState(false)

    const onSubmit = (event: FormEvent) => {
        event.preventDefault()
        if (!email.trim()) return
        setSubmitted(true)
    }

    return (
        <div className='section gold-section'>
            <div className='container'>
                <div className='golden-cta-container'>
                    <div className='w-layout-grid grid-6-col-cta'>
                        <div id='w-node-_6bb5aeaf-6b14-3c04-4aac-2b4453187d3c-53187d38' className='fade-in-move-on-scroll'>
                            <h3 className='white-text no-margins'>Put your hands first at our premium and limited products</h3>
                        </div>
                        <div id='w-node-_6bb5aeaf-6b14-3c04-4aac-2b4453187d3f-53187d38' className='center-text'>
                            <div className='newsletter-email-section'>
                                <div className='form-block w-form'>
                                    {submitted ? (
                                        <div className='success-message gold w-form-done' style={{ display: 'block' }}>
                                            <div>Thank you! Your submission has been received!</div>
                                        </div>
                                    ) : (
                                        <form name='wf-form-Newsletter-Email' method='get' className='newsletter-form' onSubmit={onSubmit}>
                                            <div className='fade-in-move-on-scroll _100width'>
                                                <label htmlFor='Newsletter-Email' className='newsletter-field-label'>
                                                    Subscribe to our newsletter.
                                                </label>
                                            </div>
                                            <div className='fade-in-move-on-scroll _100width'>
                                                <input
                                                    className='newsletter-text-field white w-input'
                                                    maxLength={256}
                                                    name='Newsletter-Email'
                                                    placeholder='E-mail'
                                                    type='email'
                                                    id='Newsletter-Email'
                                                    required
                                                    value={email}
                                                    onChange={(event) => setEmail(event.target.value)}
                                                />
                                            </div>
                                            <div className='fade-in-move-on-scroll _100width'>
                                                <input type='submit' className='button subscribe-button w-button' value='SUBSCRIBE' />
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
